import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('StyledClamps')(({ linesToShow, showReadMore, isLegal, isOverflowing, maxHeightValue }) =>
  css({
    '& > div > p': {
      color: isLegal ? '#707070' : 'inherit',
      fontSize: isLegal ? '10px' : 'inherit',
      lineHeight: isLegal ? '14px' : 'inherit',
    },

    ...(isOverflowing &&
      showReadMore && {
        maxHeight: maxHeightValue ? `${maxHeightValue}px` : 'none',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': linesToShow,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-break': 'after-white-space', // fix for iOS version 16 and below
        '-webkit-user-select': 'none' /* Safari */,
        '-moz-user-select': 'none' /* Firefox */,
        '-ms-user-select': 'none' /* Internet Explorer/Edge */,
        'user-select': 'none',
      }),
  }),
);

themeStyles.addBaseStyles('ReadMoreLess')(({ isLegal, isUnderlinedReadMore }) =>
  css({
    color: isLegal ? '#707070' : 'inherit',
    textDecoration: isUnderlinedReadMore ? 'underline' : 'none',
    paddingTop: 'xs',
    fontSize: isLegal ? '10px' : 'inherit',
    lineHeight: isLegal ? '14px' : 'inherit',
    fontFamily: 'bold',
    cursor: 'pointer',
    '-webkit-user-select': 'none' /* Safari */,
    '-moz-user-select': 'none' /* Firefox */,
    '-ms-user-select': 'none' /* Internet Explorer/Edge */,
    'user-select': 'none',
  }),
);

themeStyles.addBaseStyles('StyledBoxWrapper')(({ theme }) => {
  const greyBorder = `1px solid ${theme.colors.grey[3]}`;
  const paddingTop24 = '24px'
  return css({
    borderTop: ['', greyBorder, greyBorder],
    paddingTop: ['', paddingTop24, paddingTop24],
  });
});

export default themeStyles;
